import { useTimer } from "@/app/hooks/useTimer";

interface CountdownBarProps {
  targetDate: string;
  label?: string;
  fullWidth?: boolean;
}

export default function CountdownBar({
  targetDate,
  label = "Your next competition ends in:",
  fullWidth = false,
}: CountdownBarProps) {
  const { days, formattedHours, minutes, seconds } = useTimer("members-home-countdown", targetDate);

  return (
    <div className={`w-full flex justify-center ${fullWidth ? "px-4 lg:px-12" : "px-[18px]"}`}>
      <div
        className={`flex items-center w-full py-2 gap-1 lg:gap-2 bg-[#121212] ${
          fullWidth ? "justify-start px-4 rounded-lg lg:rounded-none" : "justify-center max-w-[518px] px-3 rounded-lg"
        }`}>
        <p className="shrink-0 m-0 p-0 text-[11px] lg:text-base font-normal font-jost leading-3.5 lg:leading-5.5 text-[#bcbcc0] whitespace-nowrap">
          {label}
        </p>
        <p className="shrink-0 m-0 p-0 text-[12px] lg:text-[18px] font-semibold font-jost leading-4 lg:leading-6 tracking-[-0.6px] lg:tracking-normal text-primary whitespace-pre">
          {`${days}d  :  ${formattedHours}h  :  ${minutes}m  :  `}
          <span className="min-w-[22px] lg:min-w-[36px] inline-block">{seconds}s</span>
        </p>
      </div>
    </div>
  );
}
